/**
 * Dosya boyutunu uygun birime formatlar
 * @param {number} bytes - Byte cinsinden dosya boyutu
 * @param {number} decimals - Ondalık basamak sayısı (varsayılan: 2)
 * @returns {string} Formatlanmış dosya boyutu (örn: "1.5 MB")
 */
export function formatFileSize(bytes, decimals = 2) {
  if (!bytes || bytes === 0) return '0 B'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

/**
 * KB cinsinden gelen dosya boyutunu formatlar
 * @param {number} kb - KB cinsinden dosya boyutu
 * @param {number} decimals - Ondalık basamak sayısı (varsayılan: 2)
 * @returns {string} Formatlanmış dosya boyutu (örn: "1.5 MB")
 */
export function formatFileSizeFromKB(kb, decimals = 2) {
  if (!kb || kb === 0) return '0 KB'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['KB', 'MB', 'GB', 'TB', 'PB']

  const i = Math.floor(Math.log(kb) / Math.log(k))

  // eslint-disable-next-line no-restricted-properties
  return `${parseFloat((kb / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

/**
 * Vue filter olarak kullanım için
 */
export default {
  install(Vue) {
    Vue.filter('fileSize', formatFileSize)
    Vue.filter('fileSizeFromKB', formatFileSizeFromKB)
  },
}
